export const networkStatusLinkConfig = {
  commandStopperDict: {
    /* features */

    // insuranceDocument/duplication
    duplicateInsuranceDocument: ['insuranceDocumentDuplicated'],

    // insuranceDocument/edit/documents/attachments
    updateAttachment: ['attachmentUpdated'],
    addAttachments: ['attachmentsAdded'],
    deleteAttachment: ['attachmentDeleted'],
    changeAttachmentState: ['attachmentStateChanged'],
    computeRequiredDocTypes: ['requiredDocTypesComputed'],
    retrieveAttachments: ['attachmentsRetrieved'],

    // insuranceDocument/edit/documents/prints
    exportDocument: ['documentExported'],
    exportDocuments: ['documentExported'],
    startDocumentsSigning: ['requestSignatureCompleted'],
    retrieveDocumentPrints: ['documentPrintsRetrieved'],

    // insuranceDocument/edit/general/actions
    computeQuotations: {
      stoppers: [
        'quotationsComputed',
        'conventionsQuotationsRetrieved',
        'computeQuotationsFailed',
        'computeQuotationsValidated',
        'retrieveConventionsValidated'
      ],
      timeout: 60000
    },

    // insuranceDocument/edit/general/asset
    updateAsset: ['assetSaved'],
    createAsset: ['assetSaved'],
    retrieveAssetImage: ['assetImageRetrieved'],

    // insuranceDocument/edit/general/driverData
    saveDrivers: ['driversSaved'],

    // insuranceDocument/edit/general/generalData
    createInsuranceDocument: ['insuranceDocumentCreated'],
    updateInsuranceDocument: ['insuranceDocumentUpdated'],
    retrieveExternalOfferData: ['externalOfferDataRetrieved'],
    copyExternalOfferData: ['externalOfferDataCopied'],

    // insuranceDocument/edit/general/insuranceData
    saveInsuranceData: ['insuranceDocumentUpdated'],

    // insuranceDocument/edit/general/partner
    savePartner: ['clientSaved', 'insuredSaved'],

    // insuranceDocument/edit/offer/casco
    saveCascoQuotation: ['cascoQuotationSaved', 'cascoCustomQuotationSaved'],
    selectQuotation: ['insuranceDocumentUpdated'],
    updateQuotationLock: ['cascoQuotationLockUpdated'],
    retrieveConventions: {
      stoppers: ['conventionsQuotationsRetrieved'],
      timeout: 60000
    },

    // insuranceDocument/edit/offer/comparator
    setOfferDetailOnDocument: ['documentOfferDetailChanged'],
    computeRCAQuotation: ['quotationComputed'],
    computeRCAQuotations: {
      stoppers: ['quotationsComputed'],
      timeout: 60000
    },
    updateInsuranceOffers: ['rcaQuotationDataChanged'],

    // insuranceDocument/edit/policy/policyData
    savePolicyData: ['policyDataSaved'],
    saveOfferData: ['offerDataSaved'],
    generatePolicy: ['changeDocumentStateFailed', 'policyGenerated'],

    // insuranceDocument/list
    saveInsuranceDocumentListTemplate: ['insuranceDocumentListTemplatesUpdated'],
    deleteInsuranceDocumentListTemplate: ['insuranceDocumentListTemplatesUpdated'],

    // insuranceDocument/stepper
    updateDocumentState: ['changeDocumentStateFailed', 'documentStateUpdated'],

    // notes
    deleteComment: ['commentDeleted'],
    addComment: ['commentAdded'],

    // ocr
    ocrUpload: ['ocrIdCardProcessed'],

    // policyRenwal
    markAsNotRenewable: ['markedAsNotRenewable'],
    generateRenewalOffers: ['generateRenewalOffersCompleted'],
    markAwaitingClientResponse: ['markedAwaitingClientResponseCompleted'],
    recomputeRenewalQuotations: ['recomputeRenewalQuotationsCompleted'],
    updateRenewalInsuranceOffers: ['renewalInsuranceQuotationsUpdated'],
    updateInsuranceDocumentComments: ['insuranceDocumentCommentsUpdated'],

    // serviceLogs
    retrieveInsuranceServiceLogs: ['insuranceServiceLogsRetrieved'],

    // settings
    resetCache: ['cacheCredentialsReset', 'cacheConfigurationsReset'],
    checkService: ['serviceConnectionChecked'],
    erpVersion: ['erpVersionData'],
    requestDeimosVersion:
      null /*["deimosVersionRetrieved"], <= Deimos service is optional. If no subscription comes, the loader will get stuck => the subscription should no longer be awaited */,

    // verification
    retryDocumentVerification: ['documentVerificationUpdated'],

    // workflow
    terminateWorkflow: null,
    restartWorkflow: null,
    retryWorkflow: null,
    resumeWorkflow: null,
    pauseWorkflow: null,

    /* hooks */
    singleUpload: null
  },
  excludedQueries: ['documentWorkflows']
};
